import React , { useState,useEffect }from 'react'
import { Button,  Form, Input} from 'antd';
import './login.css';
import {userLogin,getConfig} from './service';
import checkLogin from '../../request/checkLogin.js'
import { encrypt,decrypt,localStorageSet,localStorageGet } from '../../utils/global.js';
import { setCatch } from '../../utils/auth';

const Login =(props)=>{
    const [form] = Form.useForm();
    const [bChecked,setChecked] = useState(false);

    useEffect(() => {
      JgetConfig();

      var localLoginfo = localStorageGet('loginfo');
      // console.log('localLoginfo:----------- ', localLoginfo);
      if(localLoginfo){
        var loginfo_ = JSON.parse(decrypt(localLoginfo));
        // console.log('loginfo_--------------', loginfo_)
        form.setFieldValue('userName', loginfo_.userName);
        form.setFieldValue('password', loginfo_.password);
        setChecked(true);
      }
      else{
        setTimeout(()=>{
          form.setFieldValue('userName', "");
          form.setFieldValue('password', "");
          setChecked(false);

        }, 100)
      }
    }, [form]);

    const JgetConfig = async () =>{
      var param = {"f":"J_getConfig","p":{}};
      getConfig(param).then((res) => {
        console.log(res);
        if(res.c !== 0){
         
        }
        else{
          var logo = res.d.config.judgelogo;
          var banner = res.d.config.loginbanner;
          var cszndownurl = res.d.config.cansaizhinan;
          console.log(logo);
          var bannerobj = document.getElementById("bannerbox");
          var logoobj = document.getElementById("logobox");
          var downobj = document.getElementById("downloadurl");
          if(logo != undefined && logo != ''){
            logoobj.innerHTML = '<img id="logo" src="'+logo+'" alt="" width="120px" />';
          }
          else{
            logoobj.innerHTML = '<img id="logo" src="../../img/logo-05.png" alt="" width="120px" />';
          }
          if(banner != undefined && banner != ''){
            bannerobj.innerHTML = '<img id="logo" src="'+banner+'" alt="" style="width:80%;max-height:300px;margin-top:10px;" />';
          }
          else{
            bannerobj.innerHTML = '<img id="logo" src="../../img/banner.png" alt="" style="width:80%;max-height:300px;margin-top:10px;" />';
          }
          if(cszndownurl != undefined && cszndownurl != ""){
            downobj.innerHTML = "<a href='"+cszndownurl+"'>点击下载</a>";
          }
        }
      })
    }

    const onFinish = async(value)=>{
        // console.log(value);
        // console.log(bChecked);
        localStorage.removeItem('token');

        if(bChecked){
          localStorageSet("loginfo", encrypt(JSON.stringify({"userName":value.userName, "password":value.password})));
        }
        else{
          localStorage.removeItem("loginfo");
        }
        try {
          var param = {"f":"J_login","p":{"account":value.userName,"passwd":value.password}};
            return await userLogin(param).then((res) => {
              // console.log(res);
              var flag = checkLogin(res)
              if (flag) {
                // localStorage.setItem('token',res.d.token);
                setCatch("token",res.d.token);
                setCatch("name",value.userName);
                setCatch("level",res.d.level);
                window.location.href = './#/list';
              }
            });
          } catch (error) {
            
            return false;
          }
    }
  return (
    <div  id="box" className='container'>
        <div style={{background:"white", borderRadius:18, overflow:'hidden',width:"100%"}}>
            <div id="bannerbox" style={{maxHeight:"300px",width:"100%"}}></div>
            <Form form={form}
            className='loginForm'
            name="normal_login"
            // labelCol={{span: 5}}
            // wrapperCol={{span: 16}}
            onFinish={onFinish}
            layout="vertical"
            // onFinishFailed={this.onFinishFailed}
            autoComplete="off"
        >
            <Form.Item
                label="账号"
                name="userName"
                className='normal_input'
                rules={[
                  {required: true, message: '请输入账号',},
                  // {pattern: /^1\d{10}$/, message: '手机号格式错误'},

                  // {max: 12,message: '用户名最多12位',},
                  // {min: 3,message: '用户名至少3位',},
                  // {pattern:/^[a-zA-Z0-9_]+$/,message: '用户名必须是英文、字母或下划线',},

                    // {
                    // required: true,
                    // message: '请输入您的手机号！',
                    // },
                ]}
            >
            <Input placeholder="请输入账号" bordered={false} className="m_input" />
            </Form.Item>
            <Form.Item
                label="密码"
                name="password"
                rules={[
                  {required: true,message: '密码必须6-30个字符',},
                  {max: 30,message: '密码最多30位',},
                  {min: 6,message: '密码至少6位',},
                  // {pattern:^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$,message: '密码必须包含字母和数字',},
                ]}
            >
            <Input.Password  placeholder="密码必须6-30个字符" bordered={false} />
            </Form.Item>
            {/* <Form.Item>
            <a href="/#/login/forgetpwd" style={{float:"right",color: "rgba(0, 0, 0, 0.5)"}}>忘记密码</a>
            </Form.Item> */}
            <Form.Item>
            <div style={{textAlign:"center"}}>
            <Button type="primary" htmlType="submit" style={{width: 150,height:50,borderRadius: 30,backgroundColor: "#9864C9",borderColor: "#9864C9",fontSize: 20,marginTop:30}}>
                登录
            </Button>
            </div>
            {/* <div style={{marginTop:20}}>还没有账号，<a href="/#/register" style={{color:"red"}}>去注册</a></div> */}
            </Form.Item>
        </Form>
        <div style={{height:120,marginBottom:30}}>
          <div style={{textAlign:"left", marginLeft:30, paddingTop:20, color:"#afa178", float:"left"}}>
            {/* <div>TopDigital创新营销奖参赛指南 点击下载</div>
            <div>TopDigital创新营销奖参赛报名+作品描述模板 点击下载</div>
            <div>TopDigital创新营销奖参赛作品报送指南 点击下载</div> */}
            <div>&nbsp;</div><div>&nbsp;</div>
            <div>TBI创新营销奖评审指南 <span id="downloadurl">&nbsp;</span></div>
            {/* <div style={{marginTop:10}}>参赛咨询：021-61150705、021-61150706</div> */}
          </div>
          <div id="logobox" style={{paddingRight:30, float:"right",height:"120px",width:"120px",marginRight:"10px" ,display:"flex",justifyContent:"center", alignItems: "center"}}>
            {/* <img src={[require("../../img/logo-05.png")]} alt="" height="120px" /> */}
          </div>
        </div>
        </div>

    </div>
  )
}
export default Login
